define("settings/templates/overview/display", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{this.closeModal}} @focusTrap={{true}} as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header @title={{t "account.overview.display.title"}} />
      <modal.card-body>
        <Shared::Locale />
      </modal.card-body>
      <modal.card-footer>
        <Shared::Ui::Button @onClick={{this.closeModal}} @variant="outline" class="u--float--right">
          {{t "shared_words.close"}}
        </Shared::Ui::Button>
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "BBjxSIZl",
    "block": "[[[8,[39,0],null,[[\"@close\",\"@focusTrap\"],[[30,0,[\"closeModal\"]],true]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],null,[[\"@title\"],[[28,[37,1],[\"account.overview.display.title\"],null]]],null],[1,\"\\n    \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,2],null,null,null],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,3],[[24,0,\"u--float--right\"]],[[\"@onClick\",\"@variant\"],[[30,0,[\"closeModal\"]],\"outline\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,1],[\"shared_words.close\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\"],false,[\"shared/modal\",\"t\",\"shared/locale\",\"shared/ui/button\"]]",
    "moduleName": "settings/templates/overview/display.hbs",
    "isStrictMode": false
  });
});